module.exports = __webpack_public_path__ + "static/loop-5735d771367ec151ce5345d25cbeb808.mp4";